// @ts-strict-ignore
import {apiClient} from 'common/util/api-client';
import {ApiResourceClient} from 'common/util/model-resource/api-resource';
import {purgeFetchCache} from 'common/report/queries/utils/fetch-cache';
import {ContentType, DashboardCard} from 'common/report/dashboards/types';
import {getCardIdFromContent} from 'common/report/util/dashboards/utils';
import {getReportCard} from 'common/report/controllers/dashboard-model-controller';

import {appApiUrl} from '../utils';

type Bookmark = {
  id: string;
  user_id: string;
  user: string;
  name: string;
  include_in_dashboard: boolean;
  is_default: boolean;
  type: string;
  created: string;
  modified: string;
  params: string;
};

export type PinnedBookmarkResults = {
  order: number;
  auto_pinned: boolean | null;
  bookmark: Bookmark;
};

export type PinnedCards = Array<DashboardCard | undefined>;

const NUMBER_OF_CARDS = 3;
const DEFAULT_EMPTY_CARDS: PinnedCards = Array(NUMBER_OF_CARDS).fill(undefined);

export async function updatePinnedCard(
  projectId: string,
  bookmarkId: number,
  order: number,
): Promise<PinnedBookmarkResults> {
  const url = getUrl(projectId);
  return apiClient.post(url, {bookmark_id: bookmarkId, order: Number(order)});
}

function getUrl(projectId: string) {
  return appApiUrl(`users/home-pinned-bookmarks`, {projectId});
}

const formatBookmarkAsDashboardCard = (bookmark: Bookmark, autoPinned?: boolean | null): DashboardCard => {
  const singleBookmarkHash = {
    [bookmark.id]: bookmark,
  };
  const cardId = getCardIdFromContent(bookmark.id, ContentType.Report);
  const card = getReportCard(singleBookmarkHash, bookmark.id, null, null, cardId) as DashboardCard;
  card.auto_pinned = autoPinned;
  return card;
};

export const formatCardsInOrder = (pinnedCards: PinnedBookmarkResults[]): PinnedCards => {
  if (!pinnedCards) return DEFAULT_EMPTY_CARDS;

  const newCardsInOrder = [...DEFAULT_EMPTY_CARDS];
  pinnedCards.forEach((card) => {
    newCardsInOrder[card.order] = formatBookmarkAsDashboardCard(card.bookmark, card.auto_pinned);
  });
  return newCardsInOrder;
};

export const pinnedCardClient: ApiResourceClient<PinnedBookmarkResults[]> = {
  index() {
    throw new Error(`pinnedCardClient does not support index queries`);
  },

  get(id: string) {
    return apiClient.hydratedGet<PinnedBookmarkResults[]>(getUrl(id));
  },

  purgeCache(id: string) {
    purgeFetchCache({everything: true, path: getUrl(id)});
  },
};
